import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('../views/HomeView.vue')
        },
        {
            path: '/company',
            name: 'company',
            component: () => import('../views/CompanyView.vue')
        },
        {
            path: '/appliances',
            name: 'appliances',
            component: () => import('../views/AppliancesView.vue')
        },
        {
            path: '/e-commerce',
            name: 'e-commerce',
            component: () => import('../views/ECommerceView.vue')
        },
        {
            path: '/it',
            name: 'it',
            component: () => import('../views/ITView.vue')
        },
        {
            path: '/invitation',
            name: 'invitation',
            component: () => import('../views/InvitationView.vue')
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('../views/NewsView.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('../views/ContactView.vue')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            setTimeout(() => {
                // 强制滚动到顶部的两种方法
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

                resolve({ top: 0, behavior: 'smooth' });
            }, 200); // 增加延迟时间
        });
    }
})
